import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {AlertService} from 'src/app/service/alert.service';
import {MessageService} from 'primeng/api';
import {AlertType} from 'src/app/models/alert-configuration.model';
import {finalize, Subject, takeUntil} from "rxjs";
import {DataTablePage} from 'src/app/models/data-table-page.model';

@Component({
  selector: 'real-time-events-window',
  templateUrl: './events-window.component.html',
  styleUrls: ['./events-window.component.scss']
})
export class EventsWindowComponent implements OnInit, OnDestroy {

  stylePattern = {'min-width': '100%', 'max-width': '100%', 'height': '40px'};

  private _destroy$: Subject<void> = new Subject<void>();
  @Input() dialogShow: boolean = false;
  @Output() dialogShowChange = new EventEmitter<boolean>();
  private _devices!: Array<any>;

  @Input()
  set devices(devices: Array<any>) {
    this._devices = devices;
  }

  get devices() {
    return this._devices;
  }

  showSpinnerAlerts = false;
  showSpinnerAlertsFiltered = false;

  eventsTypeOptions: any = [];
  alerts: any = [];
  alertsFiltered: any = [];

  page!: DataTablePage;
  first: number = 0;
  totalRecords: number = 0;
  currentFilter: any = [];
  alertPage!: DataTablePage;
  alertFirst: number = 0;
  alertFilter: any = [];
  alertTotalRecords: number = 0;
  alertCurrentFilter: any = [];
  rangeDates: Date[] | undefined = undefined;
  maxDate: Date = new Date();

  notFoundLastAlerts: boolean = false;
  tituloNotFoundLastAlerts: string = 'Nenhum evento encontrado';
  descricaoNotFoundLastAlerts: string = 'Não encontramos nenhum evento recente para este equipamento';

  notFoundAlertsFiltered: boolean = false;
  tituloNotFoundAlertsFiltered: string = 'Nenhum evento encontrado';
  descricaoNotFoundAlertsFiltered: string = 'Não encontramos nenhum evento para os filtros informados';


  tipoFiltroOptions: any[] = [
    { name: 'Dia', code: `dia` },
    { name: 'Hora', code: `hora` },
  ];

  constructor(
    private alertService: AlertService,
    private messageService: MessageService) {
      this.page = new DataTablePage();
      this.page.size = 10;
      this.page.pageNumber = 0;
      this.alertPage = new DataTablePage();
      this.alertPage.size = 10;
      this.alertPage.pageNumber = 0;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dialogShow'] && changes['dialogShow'].previousValue === true && changes['dialogShow'].currentValue === false) {
      this.cleanDialog();
    }
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  ngOnInit(): void {
    this.getEventsType();
  }

  getEventsType(){
    this.alertService.getEventType(this.devices)
    .pipe(
      takeUntil(this._destroy$),
    )
    .subscribe({
      next: (resultData) => {
        this.eventsTypeOptions = resultData;
      },
      error: (error) => {},
    });
  }

  getDeviceAlerts(pageEvent: any, filters: any) {
    this.notFoundLastAlerts = false;
    this.showSpinnerAlerts = true;
    this.page.pageNumber = pageEvent.first / this.page.size;
    if (pageEvent === false) {
      this.page.pageNumber = 0;
      this.first = 0;
    }
    if(filters === false){
      filters = [];
    }
    filters.device = this.devices;
    this.currentFilter = {
      ...filters,
    };
    this.alertService.getAllAlertByDeviceId(this.page, this.currentFilter)
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => this.showSpinnerAlerts = false),
      )
      .subscribe({
        next: (resultData) => {
          this.alerts = resultData.content;
          this.totalRecords = this.page.totalElements;
          if (!resultData.content || resultData.content.length === 0) {
            this.notFoundLastAlerts = true;
            this.tituloNotFoundLastAlerts = 'Nenhum evento encontrado';
            this.descricaoNotFoundLastAlerts = 'Não encontramos nenhum evento recente para este equipamento';
          }
        },
        error: (error) => {
          this.messageService.add({
            key: 'toastError',
            severity: 'error',
            summary: 'Error',
            detail: 'Erro ao tentar carregar eventos recentes',
          });
        },
      });

  }

  getDeviceAlertsFiltered(pageEvent: any, filters: any) {
    this.notFoundAlertsFiltered = false;
    this.showSpinnerAlertsFiltered = true;
    this.alertPage.pageNumber = pageEvent.first / this.alertPage.size;
    if (pageEvent === false) {
      this.alertPage.pageNumber = 0;
      this.alertFirst = 0;
      if (this.rangeDates !== undefined && this.rangeDates !== null) {
        if (this.validateDates()) {
            this.showSpinnerAlertsFiltered = false;
            this.messageService.add({
              key: 'toastError',
              severity: 'error',
              summary: 'Data inválida',
              detail: 'Não é possível selecionar datas futuras. Por favor, selecione um período até a data atual.',
            });
            return;
          }
        if(this.rangeDates.length!==0){
          this.alertFilter.startDate = this.rangeDates[0];
          this.alertFilter.endDate = this.rangeDates[1];
        }
      }
    }
    if(filters === false){
      filters = [];
    }
    filters.device = this.devices;
    this.alertCurrentFilter = {
      ...filters,
    };
    this.alertService.getFilteredALerts(this.alertPage, this.alertCurrentFilter)
      .pipe(
        takeUntil(this._destroy$),
        finalize(() => this.showSpinnerAlertsFiltered = false),
      )
      .subscribe({
        next: (resultData) => {
          this.alertsFiltered = resultData.content;
          this.alertTotalRecords = this.alertPage.totalElements;
          if (!resultData.content || resultData.content.length === 0) {
            this.notFoundAlertsFiltered = true;
            this.tituloNotFoundAlertsFiltered = 'Nenhum evento encontrado';
            this.descricaoNotFoundAlertsFiltered = 'Não encontramos nenhum evento para os filtros informados';
          }
        },
        error: (error) => {
          this.messageService.add({
            key: 'toastError',
            severity: 'error',
            summary: 'Error',
            detail: 'Erro ao tentar carregar eventos',
          });
        },
      });

  }

  getAlertColor(color: string){
    switch (color){
      case 'Vermelho':
        return '#d10808'
      case 'Amarelo':
        return '#c2c732'
      case 'Cinza':
        return '#737272'
      case 'Verde':
        return '#1bc900'
      case 'Azul':
        return '#006fc9'
      default:
        return '#737272'
    }
  }

  tabChange(event: any) {
    if (event.index === 0 && this.alerts.length < 1) {
      this.getDeviceAlerts(false, this.currentFilter);
    }
  }

  clearFilter() {
    this.alertFilter = [];
    this.rangeDates = [];
    this.alertsFiltered = [];
    this.alertTotalRecords = 0;
    this.alertFirst = 0;
    this.notFoundAlertsFiltered = false;
    this.alertPage = new DataTablePage();
    this.alertPage.size = 10;
    this.alertPage.pageNumber = 0;
  }


  getAlertTypeString(alert: string) {
    switch (alert) {
      case AlertType.weight:
        return 'Excesso de Peso'
        case AlertType.speed:
        return 'Excesso de Velocidade'
        case AlertType.temperature:
          return 'Temperatura Crítica'
      default:
        return ''
    }
  }

  validateDates(): boolean {
    if (this.rangeDates && this.rangeDates.length >= 2) {
      const today = new Date();
      today.setHours(23, 59, 59, 999);

      const startDate = new Date(this.rangeDates[0]);
      const endDate = new Date(this.rangeDates[1]);

      return startDate > today || endDate > today;
    }
    return false;
  }

  verifyVariables(): boolean {
    if (this.rangeDates !== undefined && this.rangeDates !== null) {
      if(this.rangeDates.length===0){
        return true;
      }
      if(this.rangeDates[1]===null){
        return false;
      }
    }
    return true;
  }

  closeEventsWindow() {
    this.dialogShow = false;
    this.cleanDialog();
  }

  cleanDialog() {
    this.page = new DataTablePage();
    this.page.size = 10;
    this.page.pageNumber = 0;
    this.alertPage = new DataTablePage();
    this.alertPage.size = 10;
    this.alertPage.pageNumber = 0;
    this.totalRecords = 0;
    this.alertTotalRecords = 0;
    this.alerts = [];
    this.alertsFiltered = [];
    this.notFoundLastAlerts = false;
    this.notFoundAlertsFiltered = false;
    this.clearFilter();
    this.dialogShowChange.emit(false);
  }

  openDialog(){
    this.getDeviceAlerts(false, this.currentFilter);
  }
}
